import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const silentErrorHandler = catchError((err) => {
    console.error(err);
    return EMPTY;
});
